import React from "react";
import useVersionsData from "../hooks/useVersionsData";
import useSavingsData from "../hooks/useSavingsData";
import ResultSingle from "./ResultSingle";
import ResultCompare from "./ResultCompare";
import ResultEmpty from "./ResultEmpty";

const Step3Results = () => {
    const { getSelectedVersions } = useVersionsData();
    const { getResultFor, getComparison, inputsAreValid } = useSavingsData();

    const selected = getSelectedVersions();

    let body;
    // Mientras falten datos para calcular (sin modelo o sin rendimiento/km del
    // vehículo actual) el paso muestra el estado inicial: ahorro en 0.
    if (!inputsAreValid()) {
        body = <ResultEmpty />;
    } else if (selected.length === 1) {
        body = (
            <ResultSingle
                version={selected[0]}
                entry={getResultFor(selected[0].id)}
            />
        );
    } else {
        body = <ResultCompare comparison={getComparison()} />;
    }

    return (
        <aside className="savings-calculator__card savings-calculator__results">
            {body}
        </aside>
    );
};

export default Step3Results;
